import * as React from 'react'
import { motion, useReducedMotion } from 'motion/react'
import { cn } from '#app/utils/misc.tsx'

const revealEase = [0.22, 1, 0.36, 1] as const

interface RevealProps {
	children: React.ReactNode
	className?: string
	delay?: number
	duration?: number
	y?: number
	scale?: number
	amount?: number
	once?: boolean
}

export function Reveal({
	children,
	className,
	delay = 0,
	duration = 0.7,
	y = 24,
	scale = 0.985,
	amount = 0.2,
	once = true,
}: RevealProps) {
	const shouldReduceMotion = useReducedMotion()

	if (shouldReduceMotion) {
		return <div className={className}>{children}</div>
	}

	return (
		<motion.div
			className={cn('will-change-transform', className)}
			initial={{ opacity: 0, y, scale }}
			whileInView={{ opacity: 1, y: 0, scale: 1 }}
			viewport={{ once, amount }}
			transition={{ duration, delay, ease: revealEase }}
		>
			{children}
		</motion.div>
	)
}
